import { colors } from 'baseui/tokens';
import { string2money } from 'common/utils/string';
import DrawerHeader from 'components/common/drawer/drawer-header';
import { DrawerBody } from 'components/common/drawer/styles';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import { OtherContainer, TotalContent, TotalItemContent } from '../../style';

interface Props {
  onClose: () => void;
  activitySales: any[];
  total: number;
}

export default function SummaryDrawer(props: Props) {
  const { t } = useTranslation();
  const { onClose } = props;

  return (
    <>
      <DrawerHeader onClose={onClose} title={t('common:other_sale_detail')} />
      <DrawerBody>
        {props.activitySales.map((schedule, idx) => {
          const guestFee = schedule.activitySaleGuests
            .filter((curr) => curr.isSelected)
            .reduce(
              (prev, curr) =>
                prev +
                (curr.activitySaleGuestDetails[0].isSelected
                  ? curr.activitySaleGuestDetails[0].totalPrice
                  : 0),
              0,
            );
          const addonsFee = schedule.activitySaleAddOns
            .filter((curr) => curr.isSelected)
            .reduce((prev, curr) => prev + curr.price, 0);
          return (
            <React.Fragment key={schedule.id}>
              <OtherContainer>
                <Text variant="LabelSmall">
                  {t('common:reschedule')} {idx + 1}
                </Text>
                <Text variant="LabelSmall">{`Rp ${string2money(
                  addonsFee + guestFee,
                )}`}</Text>
              </OtherContainer>
              <Separator gap={24} />
            </React.Fragment>
          );
        })}
        <Separator gap={16} direction="vertical">
          <div style={{ height: 1, backgroundColor: colors.gray200 }} />
        </Separator>
        <TotalContent>
          <TotalItemContent>
            <Text variant="LabelMedium">{t('common:total')}:</Text>
            <Separator gap={8} />
            <Text variant="HeadingXSmall">{`Rp ${string2money(
              props.total,
            )}`}</Text>
          </TotalItemContent>
        </TotalContent>
      </DrawerBody>
    </>
  );
}
